var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReleaseDisabledDetails = function SvgReleaseDisabledDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "21px",
    viewBox: "0 0 25 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-0.2%",
    y: "-0.1%",
    width: "100.3%",
    height: "100.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 0,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.08 0",
    type: "matrix",
    "in": "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-279.000000, -107.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(260.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AE875C",
    fillRule: "nonzero",
    points: "3.75 7.5 0 3.75 6.75 3.75 10.5 7.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#88653E",
    fillRule: "nonzero",
    transform: "translate(17.250000, 5.625000) scale(-1, 1) translate(-17.250000, -5.625000) ",
    points: "14.25 7.6 10.5 3.75 20.25 3.75 24 7.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AE875C",
    fillRule: "nonzero",
    points: "3.75 7.5 20.25 7.5 20.25 21 3.75 21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C09D75",
    fillRule: "nonzero",
    points: "3.75 7.5 10.5 7.5 10.5 21 3.75 21"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFFFFF",
    fill: "#979797",
    cx: 6,
    cy: 6,
    r: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 4,
    y: 5,
    width: 4,
    height: 2
  }))))))))));
};
export default SvgReleaseDisabledDetails;